/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportLinkCreate
 */
export interface SupportLinkCreate {
    /**
     * 
     * @type {string}
     * @memberof SupportLinkCreate
     */
    header: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupportLinkCreate
     */
    is_active: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkCreate
     */
    link_type: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkCreate
     */
    section_type: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkCreate
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof SupportLinkCreate
     */
    language_code: string;
}

/**
 * Check if a given object implements the SupportLinkCreate interface.
 */
export function instanceOfSupportLinkCreate(value: object): value is SupportLinkCreate {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('is_active' in value) || value['is_active'] === undefined) return false;
    if (!('link_type' in value) || value['link_type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('section_type' in value) || value['section_type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function SupportLinkCreateFromJSON(json: any): SupportLinkCreate {
    return SupportLinkCreateFromJSONTyped(json, false);
}

export function SupportLinkCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportLinkCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'is_active': json['is_active'],
        'link_type': json['link_type'],
        'name': json['name'],
        'section_type': json['section_type'],
        'url': json['url'],
        'language_code': json['language_code'],
    };
}

export function SupportLinkCreateToJSON(json: any): SupportLinkCreate {
    return SupportLinkCreateToJSONTyped(json, false);
}

export function SupportLinkCreateToJSONTyped(value?: SupportLinkCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'is_active': value['is_active'],
        'link_type': value['link_type'],
        'name': value['name'],
        'section_type': value['section_type'],
        'url': value['url'],
        'language_code': value['language_code'],
    };
}

